import { Meteor } from 'meteor/meteor';

import sendEmail from '../../../modules/server/send-email';
import { getEmailAddress } from '../user-operations';

const { productName } = Meteor.settings.public;
const { supportEmail } = Meteor.settings.private;

export default (user, upgradeForm) => {
  const emailAddress = getEmailAddress(user);
  let storageRequested = 0;
  if (upgradeForm.userType === 'premium-user') {
    if (upgradeForm.storageRequested > 10) {
      ({ storageRequested } = upgradeForm);
    } else {
      storageRequested = 10;
    }
  }

  let upgradeText = `The user has requested a ${upgradeForm.userType} account with ${storageRequested} GB in storage. The following apps have also been requested: `;
  const availableApps = Object.keys(upgradeForm.appRequested);
  availableApps.forEach(app => {
    if (upgradeForm.appRequested[app]) {
      upgradeText += `${app}, `;
    }
  });

  try {
    return sendEmail({
      to: 'support@srmconsulting.es',
      from: supportEmail,
      subject: `[${productName}] Upgrade Request`,
      template: 'upgrade-request',
      templateVars: {
        productName,
        emailAddress,
        upgradeText
      }
    });
  } catch (error) {
    throw new Meteor.Error('500', `${error}`);
  }
};
